// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"ff1259c0","929":"00c76b92","975":"affc4d53","990":"a1d26a41"}[chunkId] + ".chunk.js";
};